export class ImportData {
  complexDeliveryId: number;
  complexDeliveryOrderId: string;
  after: boolean = true;
}
